const storeToken = (token) => {
    console.log("TOKEN: ", token)
}

export default storeToken